import React from 'react';
import moment from 'moment';
import utils from '../../utils';

function pickFirstNonEmpty(...values) {
    for (let i = 0; i < values.length; i++) {
        const value = values[i];
        if (value !== null && value !== undefined && String(value).trim() !== '') {
            return value;
        }
    }
    return '';
}

function formatProcessDate(createdAt) {
    return createdAt ? moment(createdAt).format('DD/MM/YYYY') : '';
}

function formatOptionalDate(value) {
    if (!value) return '';
    const m = moment(value);
    return m.isValid() ? m.format('DD/MM/YYYY') : String(value);
}

function buildReportNo(createdAt, id, suffix) {
    return createdAt && id ? moment(createdAt).format('YYYYMMDD') + suffix + id : String(id || '');
}

function inspectionFromTransferStatus(status) {
    const st = String(status || '').toLowerCase();
    if (st === 'confirmed') return 'Yes';
    if (st === 'rejected') return 'No';
    if (st === 'pending_confirmation') return 'Pending';
    return status ? String(status) : '';
}

function inspectionFromReceivingStatus(status) {
    if (status === 'accepted') return 'Yes';
    if (status === 'rejected') return 'No';
    return '';
}

function statusLabelReceiving(status, rejectReason) {
    if (status === 'rejected') return `Rejected. ${rejectReason || 'No reason provided'}`;
    if (status === 'accepted') return 'Accepted';
    return status || 'Pending';
}

function statusLabelTransfer(status, rejectReason) {
    if (status === 'rejected') return `Rejected. ${rejectReason || 'No reason provided'}`;
    if (status === 'confirmed') return 'Confirmed';
    if (status === 'pending_confirmation') return 'Pending Confirmation';
    return status || 'Pending';
}

function actionDateTimeTransfer(status, updatedAt) {
    if ((status === 'confirmed' || status === 'rejected') && updatedAt) {
        return moment(updatedAt).format('DD/MM/YYYY');
    }
    return '';
}

function fgDeliveryInspection(item) {
    if (item.fgTransferInspection != null && String(item.fgTransferInspection).trim() !== '') {
        return item.fgTransferInspection;
    }
    return inspectionFromTransferStatus(item.status);
}

export const RECEIVING_SUMMARY_EXPORT_COLUMNS = [
    { key: 'no', header: 'No' },
    { key: 'reportNo', header: 'Report No' },
    { key: 'refNo', header: 'Ref No' },
    { key: 'processDate', header: 'Process Date' },
    { key: 'inspection', header: 'Inspection' },
    { key: 'partNo', header: 'Part No' },
    { key: 'description', header: 'Description' },
    { key: 'supplier', header: 'Supplier' },
    { key: 'invoiceNo', header: 'Invoice No' },
    { key: 'grnNo', header: 'GRN No' },
    { key: 'type', header: 'Type' },
    { key: 'supplierMfgDate', header: 'Supplier MFG Date' },
    { key: 'supplierMfgLotNo', header: 'Supplier MFG Lot No' },
    { key: 'lotQty', header: 'Lot Qty' },
    { key: 'receivingLocationCode', header: 'Receiving Location Code' },
    { key: 'receivingLocationDesc', header: 'Receiving Location Desc' },
    { key: 'specialRequirement', header: 'Special Requirement' },
    { key: 'storageLocation', header: 'Storage Location' },
    { key: 'lotNo', header: 'Lot No' },
    { key: 'status', header: 'Status' },
    { key: 'rejectReason', header: 'Reject Reason' },
    { key: 'remarks', header: 'Remarks' },
    { key: 'receivedBy', header: 'Received By' },
    { key: 'photoUrl', header: 'Photo URL' },
];

export const RM_TRANSFER_SUMMARY_EXPORT_COLUMNS = [
    { key: 'no', header: 'No' },
    { key: 'reportNo', header: 'Report No' },
    { key: 'refNo', header: 'Ref No' },
    { key: 'processDate', header: 'Process Date' },
    { key: 'inspection', header: 'Inspection' },
    { key: 'partNo', header: 'Part No' },
    { key: 'description', header: 'Description' },
    { key: 'jobOrderNo', header: 'Job Order No' },
    { key: 'transactionId', header: 'Transaction ID' },
    { key: 'lotNo', header: 'Lot No' },
    { key: 'qty', header: 'Qty' },
    { key: 'fromLocationCode', header: 'From Location Code' },
    { key: 'fromLocationDesc', header: 'From Location Desc' },
    { key: 'toLocationCode', header: 'To Location Code' },
    { key: 'toLocationDesc', header: 'To Location Desc' },
    { key: 'specialRequirement', header: 'Special Requirement' },
    { key: 'storageLocation', header: 'Storage Location' },
    { key: 'returnIndicator', header: 'Return' },
    { key: 'status', header: 'Status' },
    { key: 'rejectReason', header: 'Reject Reason' },
    { key: 'remarks', header: 'Remarks' },
    { key: 'actionDateTime', header: 'Action Datetime' },
    { key: 'issuedBy', header: 'Issued By' },
    { key: 'receivedBy', header: 'Received By' },
    { key: 'photoUrl', header: 'Photo URL' },
];

export const FG_TRANSFER_SUMMARY_EXPORT_COLUMNS = [
    { key: 'no', header: 'No' },
    { key: 'reportNo', header: 'Report No' },
    { key: 'refNo', header: 'Ref No' },
    { key: 'processDate', header: 'Process Date' },
    { key: 'inspection', header: 'Inspection' },
    { key: 'partNo', header: 'Part No' },
    { key: 'description', header: 'Description' },
    { key: 'jobOrderNo', header: 'Job Order No' },
    { key: 'transactionId', header: 'Transaction ID' },
    { key: 'lotNo', header: 'Lot No' },
    { key: 'manufacturingDate', header: 'Manufacturing Date' },
    { key: 'qty', header: 'Qty' },
    { key: 'fromLocationCode', header: 'From Location Code' },
    { key: 'fromLocationDesc', header: 'From Location Desc' },
    { key: 'toLocationCode', header: 'To Location Code' },
    { key: 'toLocationDesc', header: 'To Location Desc' },
    { key: 'country', header: 'Country' },
    { key: 'specialRequirement', header: 'Special Requirement' },
    { key: 'storageLocation', header: 'Storage Location' },
    { key: 'status', header: 'Status' },
    { key: 'rejectReason', header: 'Reject Reason' },
    { key: 'remarks', header: 'Remarks' },
    { key: 'actionDateTime', header: 'Action Datetime' },
    { key: 'issuedBy', header: 'Issued By' },
    { key: 'receivedBy', header: 'Received By' },
    { key: 'photoUrl', header: 'Photo URL' },
];

export const FG_DELIVERY_SUMMARY_EXPORT_COLUMNS = [
    { key: 'no', header: 'No' },
    { key: 'reportNo', header: 'Report No' },
    { key: 'refNo', header: 'Ref No' },
    { key: 'processDate', header: 'Process Date' },
    { key: 'inspection', header: 'Inspection' },
    { key: 'partNo', header: 'Part No' },
    { key: 'description', header: 'Description' },
    { key: 'poNo', header: 'PO No' },
    { key: 'doNo', header: 'DO No' },
    { key: 'transactionId', header: 'Transaction ID' },
    { key: 'lotNo', header: 'Lot No' },
    { key: 'qty', header: 'Qty' },
    { key: 'fromLocationCode', header: 'From Location Code' },
    { key: 'fromLocationDesc', header: 'From Location Desc' },
    { key: 'toLocationCode', header: 'To Location Code' },
    { key: 'toLocationDesc', header: 'To Location Desc' },
    { key: 'country', header: 'Country' },
    { key: 'deliveryOrderNo', header: 'Delivery Order No' },
    { key: 'carrier', header: 'Carrier' },
    { key: 'carrierNo', header: 'Carrier No' },
    { key: 'packagingType', header: 'Packaging Type' },
    { key: 'specialRequirement', header: 'Special Requirement' },
    { key: 'storageLocation', header: 'Storage Location' },
    { key: 'status', header: 'Status' },
    { key: 'rejectReason', header: 'Reject Reason' },
    { key: 'remarks', header: 'Remarks' },
    { key: 'actionDateTime', header: 'Action Datetime' },
    { key: 'issuedBy', header: 'Issued By' },
    { key: 'receivedBy', header: 'Received By' },
    { key: 'photoUrl', header: 'Photo URL' },
];

export function mapReceivingToExportRow(item, index) {
    const status = item.status || 'pending';
    return {
        no: index + 1,
        reportNo: buildReportNo(item.createdAt, item.id, 'R'),
        refNo: item.transactionId || '',
        processDate: formatProcessDate(item.createdAt),
        inspection: inspectionFromReceivingStatus(status),
        partNo: item.partNo || '',
        description: item.description || '',
        supplier: item.supplier || '',
        invoiceNo: item.invoiceNo || '',
        grnNo: item.grnNo || '',
        type: item.type || '',
        supplierMfgDate: formatOptionalDate(item.supplierMfgDate),
        supplierMfgLotNo: item.supplierMfgLotNo || '',
        lotQty: item.quantity ?? '',
        receivingLocationCode: item.locationCode || '',
        receivingLocationDesc: item.locationDescription || '',
        specialRequirement: item.specialRequirement || '',
        storageLocation: item.storageLocation || '',
        lotNo: item.lotNo || '',
        status: statusLabelReceiving(status, item.rejectReason),
        rejectReason: item.rejectReason || '',
        remarks: item.remarks || '',
        receivedBy: pickFirstNonEmpty(item.created_by_name, item.createdByName, item.created_by, item.createdBy),
        photoUrl: item.photoUrl || '',
    };
}

export function mapRmTransferToExportRow(item, index) {
    const status = item.status || 'pending_confirmation';
    return {
        no: index + 1,
        reportNo: buildReportNo(item.createdAt, item.id, 'T'),
        refNo: item.transactionId || '',
        processDate: formatProcessDate(item.createdAt),
        inspection: inspectionFromTransferStatus(status),
        partNo: item.partNo || '',
        description: item.description || '',
        jobOrderNo: item.jobOrderNo || '',
        transactionId: item.transactionId || '',
        lotNo: item.lotNo || '',
        qty: item.quantity ?? '',
        fromLocationCode: item.fromLocationCode || '',
        fromLocationDesc: item.fromLocationDescription || '',
        toLocationCode: item.toLocationCode || '',
        toLocationDesc: item.toLocationDescription || '',
        specialRequirement: item.specialRequirement || '',
        storageLocation: item.storageLocation || '',
        returnIndicator: item.returnIndicator ? 'Yes' : 'No',
        status: statusLabelTransfer(status, item.rejectReason),
        rejectReason: item.rejectReason || '',
        remarks: item.remarks || '',
        actionDateTime: actionDateTimeTransfer(status, item.updatedAt),
        issuedBy: pickFirstNonEmpty(
            item.created_by_name,
            item.createdByName,
            item.created_by,
            item.createdBy,
            item.issueBy,
            item.issuedBy
        ),
        receivedBy: pickFirstNonEmpty(
            item.updated_by_name,
            item.updatedByName,
            item.updated_by,
            item.updatedBy,
            item.receivedBy,
            item.receiveBy,
            item.acceptedBy
        ),
        photoUrl: item.photoUrl || '',
    };
}

export function mapFgTransferToExportRow(item, index) {
    const status = item.status || 'pending_confirmation';
    return {
        no: index + 1,
        reportNo: buildReportNo(item.createdAt, item.id, 'T'),
        refNo: item.transactionId || '',
        processDate: formatProcessDate(item.createdAt),
        inspection: inspectionFromTransferStatus(status),
        partNo: item.partNo || '',
        description: item.description || '',
        jobOrderNo: item.jobOrderNo || '',
        transactionId: item.transactionId || '',
        lotNo: item.lotNo || '',
        manufacturingDate: formatOptionalDate(item.manufacturingDate),
        qty: item.quantity ?? '',
        fromLocationCode: item.fromLocationCode || '',
        fromLocationDesc: item.fromLocationDescription || '',
        toLocationCode: item.toLocationCode || '',
        toLocationDesc: item.toLocationDescription || '',
        country: item.country || '',
        specialRequirement: item.specialRequirement || '',
        storageLocation: item.storageLocation || '',
        status: statusLabelTransfer(status, item.rejectReason),
        rejectReason: item.rejectReason || '',
        remarks: item.remarks || '',
        actionDateTime: actionDateTimeTransfer(status, item.updatedAt),
        issuedBy: pickFirstNonEmpty(
            item.created_by_name,
            item.createdByName,
            item.created_by,
            item.createdBy,
            item.issueBy,
            item.issuedBy
        ),
        receivedBy: pickFirstNonEmpty(
            item.updated_by_name,
            item.updatedByName,
            item.updated_by,
            item.updatedBy,
            item.receivedBy,
            item.receiveBy,
            item.acceptedBy
        ),
        photoUrl: item.photoUrl || '',
    };
}

function statusLabelScrap(status, rejectionReason) {
    const st = String(status || '').toLowerCase();
    if (st === 'rejected') return `Rejected. ${rejectionReason || 'No reason provided'}`;
    if (st === 'approved' || st === 'confirmed') return 'Approved';
    if (st === 'pending_approval' || st === 'pending_confirmation' || st === 'pending') {
        return 'Pending Approval';
    }
    return status ? String(status) : 'Pending';
}

function inspectionFromScrapStatus(status) {
    const st = String(status || '').toLowerCase();
    if (st === 'approved' || st === 'confirmed') return 'Yes';
    if (st === 'rejected') return 'No';
    if (st === 'pending_approval' || st === 'pending_confirmation' || st === 'pending') return 'Pending';
    return '';
}

function formatDateTime(value) {
    if (!value) return '';
    const m = moment(value);
    return m.isValid() ? m.format('DD/MM/YYYY HH:mm:ss') : String(value);
}

export const SCRAPPING_SUMMARY_EXPORT_COLUMNS = [
    { key: 'no', header: 'No' },
    { key: 'reportNo', header: 'Report No' },
    { key: 'refNo', header: 'Ref No' },
    { key: 'processDate', header: 'Submitted Date' },
    { key: 'inspection', header: 'Inspection' },
    { key: 'materialKind', header: 'Type' },
    { key: 'partNo', header: 'Part No' },
    { key: 'description', header: 'Description' },
    { key: 'lotNo', header: 'Lot No' },
    { key: 'qty', header: 'Qty' },
    { key: 'locationCode', header: 'Location Code' },
    { key: 'locationDesc', header: 'Location Desc' },
    { key: 'area', header: 'Area' },
    { key: 'reason', header: 'Reason' },
    { key: 'status', header: 'Status' },
    { key: 'submittedBy', header: 'Submitted By' },
    { key: 'approvedBy', header: 'Approved By' },
    { key: 'approvedAt', header: 'Approved Date & Time' },
    { key: 'rejectedBy', header: 'Rejected By' },
    { key: 'rejectedAt', header: 'Rejected Date & Time' },
    { key: 'rejectionReason', header: 'Rejection Reason' },
    { key: 'photoUrl', header: 'Photo URL' },
];

export function mapScrappingToExportRow(item, index) {
    const status = item.status || 'pending_approval';
    const reason = item.reason || item.scrapReason || '';
    return {
        no: index + 1,
        reportNo: buildReportNo(item.createdAt, item.id, 'S'),
        refNo: item.transactionId || '',
        processDate: formatProcessDate(item.createdAt),
        inspection: inspectionFromScrapStatus(status),
        materialKind: item.materialKind || item.transferType || '',
        partNo: item.partNo || '',
        description: item.description || '',
        lotNo: item.lotNo || '',
        qty: item.quantity ?? '',
        locationCode: item.locationCode || item.fromLocationCode || '',
        locationDesc: item.locationDescription || item.fromLocationDescription || '',
        area: item.area || '',
        reason,
        status: statusLabelScrap(status, item.rejectionReason),
        submittedBy: pickFirstNonEmpty(item.createdBy, item.created_by),
        approvedBy: pickFirstNonEmpty(item.approvedByName, item.approved_by_name),
        approvedAt: formatDateTime(item.approvedAt || item.approved_at),
        rejectedBy: pickFirstNonEmpty(item.rejectedByName, item.rejected_by_name),
        rejectedAt: formatDateTime(item.rejectedAt || item.rejected_at),
        rejectionReason: item.rejectionReason || '',
        photoUrl: item.photoUrl || '',
    };
}

export function mapFgDeliveryToExportRow(item, index) {
    const status = item.status || 'pending_confirmation';
    return {
        no: index + 1,
        reportNo: buildReportNo(item.createdAt, item.id, 'T'),
        refNo: item.transactionId || item.deliveryOrder || '',
        processDate: formatProcessDate(item.createdAt),
        inspection: fgDeliveryInspection(item),
        partNo: item.partNo || '',
        description: item.description || '',
        poNo: item.poNo || '',
        doNo: item.deliveryOrder || '',
        transactionId: item.transactionId || '',
        lotNo: item.lotNo || '',
        qty: item.quantity ?? '',
        fromLocationCode: item.fromLocationCode || '',
        fromLocationDesc: item.fromLocationDescription || '',
        toLocationCode: item.toLocationCode || '',
        toLocationDesc: item.toLocationDescription || '',
        country: item.country || '',
        deliveryOrderNo: item.deliveryOrder || '',
        carrier: item.carrier || '',
        carrierNo: item.carrierNo || '',
        packagingType: item.packagingType || '',
        specialRequirement: item.specialRequirement || '',
        storageLocation: item.storageLocation || '',
        status: statusLabelTransfer(status, item.rejectReason),
        rejectReason: item.rejectReason || '',
        remarks: item.remarks || '',
        actionDateTime: actionDateTimeTransfer(status, item.updatedAt),
        issuedBy: pickFirstNonEmpty(
            item.created_by_name,
            item.createdByName,
            item.created_by,
            item.createdBy,
            item.issueBy,
            item.issuedBy
        ),
        receivedBy: pickFirstNonEmpty(
            item.updated_by_name,
            item.updatedByName,
            item.updated_by,
            item.updatedBy,
            item.receivedBy,
            item.receiveBy,
            item.acceptedBy
        ),
        photoUrl: item.photoUrl || '',
    };
}

export function exportInventorySummary(tableId, sheetName, filenamePrefix) {
    const filename = `${filenamePrefix}_${moment().format('YYYYMMDD')}.xls`;
    utils.tableToExcel(tableId, sheetName || 'Report', filename);
}

export function InventorySummaryExportTable({ tableId, columns, rows }) {
    return (
        <div id={tableId} style={{ display: 'none' }}>
            <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.key} style={{ padding: '6px', backgroundColor: '#f0f0f0' }}>
                                {col.header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {(rows || []).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {columns.map((col) => (
                                <td key={col.key} style={{ padding: '6px' }}>
                                    {row[col.key] != null ? String(row[col.key]) : ''}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
